var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Input, Loader, Message } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { postJsonWithAuthn } from "../RequestHelpers";
var UpdateDiscountsModal = /** @class */ (function (_super) {
    __extends(UpdateDiscountsModal, _super);
    function UpdateDiscountsModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onRnaFishProbeSetCatalogChange = function (_, data) {
            var str = data.value;
            _this.setState({ rnaFishProbeSetCatalog: str });
        };
        _this.onRnaFishProbeSetCustomChange = function (_, data) {
            var str = data.value;
            _this.setState({ rnaFishProbeSetCustom: str });
        };
        _this.onRnaFishAmplifierChange = function (_, data) {
            var str = data.value;
            _this.setState({ rnaFishAmplifier: str });
        };
        _this.onRnaFishBuffersChange = function (_, data) {
            var str = data.value;
            _this.setState({ rnaFishBuffers: str });
        };
        _this.onIhc2ProbeChange = function (_, data) {
            var str = data.value;
            _this.setState({ ihc2Probe: str });
        };
        _this.onIhc2BuffersChange = function (_, data) {
            var str = data.value;
            _this.setState({ ihc2Buffers: str });
        };
        _this.onRnaCishProbeSetCatalogChange = function (_, data) {
            var str = data.value;
            _this.setState({ rnaCishProbeSetCatalog: str });
        };
        _this.onRnaCishProbeSetCustomChange = function (_, data) {
            var str = data.value;
            _this.setState({ rnaCishProbeSetCustom: str });
        };
        _this.onRnaCishAmplifierChange = function (_, data) {
            var str = data.value;
            _this.setState({ rnaCishAmplifier: str });
        };
        _this.onRnaCishBuffersChange = function (_, data) {
            var str = data.value;
            _this.setState({ rnaCishBuffers: str });
        };
        _this.onGoldRnaFishProbeSetCatalogChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldRnaFishProbeSetCatalog: str });
        };
        _this.onGoldRnaFishProbeSetCustomChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldRnaFishProbeSetCustom: str });
        };
        _this.onGoldRnaFishAmplifierChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldRnaFishAmplifier: str });
        };
        _this.onGoldRnaFishBuffersChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldRnaFishBuffers: str });
        };
        _this.onGoldIhc2ProbeChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldIhc2Probe: str });
        };
        _this.onGoldIhc2BuffersChange = function (_, data) {
            var str = data.value;
            _this.setState({ goldIhc2Buffers: str });
        };
        _this.onManualProDetectChange = function (_, data) {
            var str = data.value;
            _this.setState({ manualProDetect: str });
        };
        _this.submit = function () {
            _this.setState({
                loading: true,
            }, function () {
                postJsonWithAuthn("/admin/users/id/" + encodeURIComponent(_this.props.userId) + "/discounts", JSON.stringify({
                    discounts: {
                        rnaFishProbeSetCatalog: _this.state.rnaFishProbeSetCatalog,
                        rnaFishProbeSetCustom: _this.state.rnaFishProbeSetCustom,
                        rnaFishAmplifier: _this.state.rnaFishAmplifier,
                        rnaFishBuffers: _this.state.rnaFishBuffers,
                        ihc2Probe: _this.state.ihc2Probe,
                        ihc2Buffers: _this.state.ihc2Buffers,
                        rnaCishProbeSetCatalog: _this.state.rnaCishProbeSetCatalog,
                        rnaCishProbeSetCustom: _this.state.rnaCishProbeSetCustom,
                        rnaCishAmplifier: _this.state.rnaCishAmplifier,
                        rnaCishBuffers: _this.state.rnaCishBuffers,
                        goldRnaFishProbeSetCatalog: _this.state.goldRnaFishProbeSetCatalog,
                        goldRnaFishProbeSetCustom: _this.state.goldRnaFishProbeSetCustom,
                        goldRnaFishAmplifier: _this.state.goldRnaFishAmplifier,
                        goldRnaFishBuffers: _this.state.goldRnaFishBuffers,
                        goldIhc2Probe: _this.state.goldIhc2Probe,
                        goldIhc2Buffers: _this.state.goldIhc2Buffers,
                        manualProDetect: _this.state.manualProDetect
                    }
                })).then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true,
                            errors: []
                        });
                        return;
                    }
                    else {
                        return resp.json();
                    }
                }).then(function (resp) {
                    if (resp !== undefined) {
                        _this.setState({
                            loading: false,
                            success: false,
                            errors: resp.errors
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            success: true,
                            errors: []
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't submit comment: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            errors: [],
            rnaFishProbeSetCatalog: props.initialValues.rnaFishProbeSetCatalog,
            rnaFishProbeSetCustom: props.initialValues.rnaFishProbeSetCustom,
            rnaFishAmplifier: props.initialValues.rnaFishAmplifier,
            rnaFishBuffers: props.initialValues.rnaFishBuffers,
            ihc2Probe: props.initialValues.ihc2Probe,
            ihc2Buffers: props.initialValues.ihc2Buffers,
            rnaCishProbeSetCatalog: props.initialValues.rnaCishProbeSetCatalog,
            rnaCishProbeSetCustom: props.initialValues.rnaCishProbeSetCustom,
            rnaCishAmplifier: props.initialValues.rnaCishAmplifier,
            rnaCishBuffers: props.initialValues.rnaCishBuffers,
            goldRnaFishProbeSetCatalog: props.initialValues.goldRnaFishProbeSetCatalog,
            goldRnaFishProbeSetCustom: props.initialValues.goldRnaFishProbeSetCustom,
            goldRnaFishAmplifier: props.initialValues.goldRnaFishAmplifier,
            goldRnaFishBuffers: props.initialValues.goldRnaFishBuffers,
            goldIhc2Probe: props.initialValues.goldIhc2Probe,
            goldIhc2Buffers: props.initialValues.goldIhc2Buffers,
            manualProDetect: props.initialValues.manualProDetect
        };
        return _this;
    }
    UpdateDiscountsModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/rnaFishProbeSetCatalog', labelContent: "RNA-FISH (v3.0) Probe - catalog" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onRnaFishProbeSetCatalogChange, value: this.state.rnaFishProbeSetCatalog })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/rnaFishProbeSetCustom', labelContent: "RNA-FISH (v3.0) Probe - custom" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onRnaFishProbeSetCustomChange, value: this.state.rnaFishProbeSetCustom })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/rnaFishAmplifier', labelContent: "RNA-FISH / 2ºIHC (v3.0) Amplifier" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onRnaFishAmplifierChange, value: this.state.rnaFishAmplifier })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/rnaFishBuffers', labelContent: "RNA-FISH (v3.0) Buffers" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onRnaFishBuffersChange, value: this.state.rnaFishBuffers })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/ihc2Probe', labelContent: "2ºIHC (v3.0) Probe" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onIhc2ProbeChange, value: this.state.ihc2Probe })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/ihc2Buffers', labelContent: "2ºIHC (v3.0) Buffers" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onIhc2BuffersChange, value: this.state.ihc2Buffers })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/rnaCishProbeSetCatalog', labelContent: "RNA-ISH Probe - catalog" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onRnaCishProbeSetCatalogChange, value: this.state.rnaCishProbeSetCatalog })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/rnaCishProbeSetCustom', labelContent: "RNA-ISH Probe - custom" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onRnaCishProbeSetCustomChange, value: this.state.rnaCishProbeSetCustom })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/rnaCishAmplifier', labelContent: "RNA-ISH Amplifier" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onRnaCishAmplifierChange, value: this.state.rnaCishAmplifier })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/rnaCishBuffers', labelContent: "RNA-ISH Buffers" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onRnaCishBuffersChange, value: this.state.rnaCishBuffers })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldRnaFishProbeSetCatalog', labelContent: "Gold RNA-FISH Probe - catalog" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldRnaFishProbeSetCatalogChange, value: this.state.goldRnaFishProbeSetCatalog })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldRnaFishProbeSetCustom', labelContent: "Gold RNA-FISH Probe - custom" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldRnaFishProbeSetCustomChange, value: this.state.goldRnaFishProbeSetCustom })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldRnaFishAmplifier', labelContent: "Gold RNA-FISH / IF Amplifier" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldRnaFishAmplifierChange, value: this.state.goldRnaFishAmplifier })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldRnaFishBuffers', labelContent: "Gold RNA-FISH Buffers" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldRnaFishBuffersChange, value: this.state.goldRnaFishBuffers })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldIhc2Probe', labelContent: "Gold 2ºIF Probe" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldIhc2ProbeChange, value: this.state.goldIhc2Probe })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/goldIhc2Buffers', labelContent: "Gold 2ºIF Buffers" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onGoldIhc2BuffersChange, value: this.state.goldIhc2Buffers })),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/discounts/manualProDetect', labelContent: "Manual Pro Detect" },
                React.createElement(Input, { placeholder: 'No discount', onChange: this.onManualProDetectChange, value: this.state.manualProDetect })),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Discounts updated."),
            React.createElement(Button, { disabled: this.state.success, icon: 'save', label: 'Update discounts', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return UpdateDiscountsModal;
}(React.PureComponent));
export default UpdateDiscountsModal;
;
//# sourceMappingURL=UpdateDiscountsModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/UpdateDiscountsModal.js
// module id = 1311
// module chunks = 0